import styled, { createGlobalStyle } from "styled-components";

export const LarguraModal = createGlobalStyle`
  .modal-reprocessar {
    max-width: 560px;
  }
`;

export const Pergunta = styled.p`
  text-align: center;
  margin: 0.5rem 0 1.25rem;
`;

export const TextoInfo = styled.span`
  font-size: 0.875rem;
`;

export const EspacoAntesDoRodape = styled.div`
  margin-bottom: 0.75rem;
`;
